import successCheckDark from '@rhg/../public/_n/animations/success_check_dark.json';

export default successCheckDark;
